import {
  getAdminFeeBulkPreCreation,
  getCampaignDetail,
  getCampaignMembers,
  getStatusCampaign,
} from 'src/clients';
import { ColumnConfigSchema } from './reducers';
import { ACTION_TYPES } from './types';

export const loadBulkDisbursementList = (params: any) => {
  return {
    types: [
      ACTION_TYPES.BULK_DISBURSEMENT_LIST,
      ACTION_TYPES.BULK_DISBURSEMENT_LIST_SUCCESS,
      ACTION_TYPES.BULK_DISBURSEMENT_LIST_FAILED,
    ],
    client: () => getStatusCampaign(params),
  };
};

export const showModalCustom = (show: boolean) => {
  return {
    type: ACTION_TYPES.BULK_DISBURSEMENT_LIST_SHOW_MODAL,
    payload: show,
  };
};

export const showChooseCreateModal = (show: boolean) => {
  return {
    type: ACTION_TYPES.BULK_DISBURSEMENT_LIST_CREATE,
    payload: show,
  };
};

export const updateCustomColumn = (columns: Array<ColumnConfigSchema>) => {
  return {
    type: ACTION_TYPES.BULK_DISBURSEMENT_LIST_COLUMN,
    payload: columns,
  };
};

export const loadBulkDisbursementDetail = (params: any) => {
  return {
    types: [
      ACTION_TYPES.BULK_DISBURSEMENT_DETAIL,
      ACTION_TYPES.BULK_DISBURSEMENT_DETAIL_SUCCESS,
      ACTION_TYPES.BULK_DISBURSEMENT_DETAIL_FAILED,
    ],
    client: () => getCampaignDetail(params),
  };
};

export const showModalCustomDetail = (show: boolean) => {
  return {
    type: ACTION_TYPES.BULK_DISBURSEMENT_DETAIL_SHOW_MODAL,
    payload: show,
  };
};

export const updateCustomColumnDetail = (
  columns: Array<ColumnConfigSchema>,
) => {
  return {
    type: ACTION_TYPES.BULK_DISBURSEMENT_DETAIL_COLUMN,
    payload: columns,
  };
};

export const loadBulkDisbursementDetailTransaction = (params: any) => {
  return {
    types: [
      ACTION_TYPES.BULK_DISBURSEMENT_DETAIL_TRANSACTION,
      ACTION_TYPES.BULK_DISBURSEMENT_DETAIL_TRANSACTION_SUCCESS,
      ACTION_TYPES.BULK_DISBURSEMENT_DETAIL_TRANSACTION_FAILED,
    ],
    client: () => getCampaignMembers(params),
  };
};

export const loadAdminFeePreCreation = () => {
  return {
    types: [
      ACTION_TYPES.ADMIN_FEE_PRECREATION,
      ACTION_TYPES.ADMIN_FEE_PRECREATION_SUCCESS,
      ACTION_TYPES.ADMIN_FEE_PRECREATION_FAILED,
    ],
    client: () => getAdminFeeBulkPreCreation(),
  };
};
